export enum UrlAction {
  CONFIRM_EMAIL = "confirm-email",
  CHANGE_EMAIL = "change-email",
  RESET_PASSWORD = "reset-password",
}

export enum UrlParam {
  OPEN_MODAL = "openModal",
  EMAIL = "e",
  INVITE_TOKEN = "it",
  KEY = "k",
  ACTION = "action",
  REFERRAL_CODE = "r",
  TAB = "tab",
  USER = "user",
  MEMBER = "member",
  TYPE = "type",
  STATUS = "status",
  ORDER = "order",
  SEARCH = "search",
  FILTER = "filter",
  CALLBACK_URL = "callbackUrl",
  ERROR = "error",
}

export const Urls = {
  WEBSITE: "https://meidly.com",
  WEBSITE_DISPLAY: "meidly.com",
  ASSETS_LOGO: "/assets/images/logo.png",
};

export const AUTH_CLEAR_SESSION_PATH = "/api/auth/clear-session";
